const ErrorMessage = ({ children }) => (
  <div className="mt-4 text-sm text-red-600">{children}</div>
);

export default ErrorMessage;
